import './components/registration/init-components-registration';

document.addEventListener('DOMContentLoaded', () => {
    window.console.log('registration');
});
